<template>
  <div>
    <v-container fluid class="py-0 pt-3">
      <Breadcrumbs />
    </v-container>
    <tiles-page
      title="База знаний"
      :link-groups="linkGroups"
      sm="12"
      md="6"
    />
  </div>
</template>

<script>
  import TilesPage from '@/components/ui/TilesPage.vue'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'
  import RouteName from '@/models/enums/RouteName'

  export default {
    name: 'KnowledgeBaseIndex',
    components: { TilesPage },
    data () {
      return {
        linkGroups: [
          {
            title: 'Приложения и модули',
            links: [
              {
                icon: 'download',
                cols: 12,
                routeName: RouteName.KnowledgeBaseDownloads,
                title: 'Загрузки и требования к оборудованию',
              },
            ],
          },
          {
            title: 'Инструкции',
            links: [
              {
                icon: 'plug',
                cols: 12,
                routeName: RouteName.KnowledgeBaseFilialConnection,
                title: 'Подключение филиала к ФАКТ',
                permissions: [CRMPermission.KnowledgeBaseFilialConnection],
              },
            ],
          },
        ],
      }
    },
  }
</script>
